import { SearchService } from "./../../shared/services/search.service";
import { UserService } from "./../../shared/services/user.service";
import { Customer } from "./../../shared/models/customer";
import { ArticleFilter, FilterContainer } from "./../../shared/models/article";
import { Component, OnInit } from "@angular/core";
import { ArticleService } from "../../shared/services/article.service";
import { Article } from "../../shared/models/article";
import { ActivatedRoute, Params } from "@angular/router";
import { PreferenceService } from "../../shared/services/preference.service";

@Component({
    selector: "app-home-four",
    templateUrl: "./home-four.component.html",
    styleUrls: ["./home-four.component.scss"],
    standalone: false
})
export class HomeFourComponent implements OnInit {
  public articles: Article[] = [];
  departmentId: number = null;
  loading: boolean;
  page: number;
  cantpages: number;
  articleFilter: ArticleFilter;
  customer: Customer;

  constructor(
    private articleService: ArticleService,
    private activatedRoute: ActivatedRoute,
    private userService: UserService,
    public preferenceService: PreferenceService
  ) {
    this.loading = true;
    this.articleFilter = new ArticleFilter();
  }

  ngOnInit() {
    const filter: FilterContainer = this.articleService.getStorage();
    this.activatedRoute.params.forEach((params: Params) => {
      this.customer = this.userService.getIdentity();
      this.page = filter ? filter.page : 1;
      this.articleFilter.articleFind = params.article || "";
      this.departmentId = params.departmentId || null;
      this.getProducts(params.article, params.departmentId);
    });
  }

  getProducts = (articleName: string, departmentId: number) => {
    this.loading = true;
    const article: Article = new Article();
    article.name = articleName || "";
    article.departmentId = departmentId || null;
    article.fromClient = true;
    this.articleService.setStorage({ article, departmentId, page: this.page });
    this.articleService.getArticles(this.page, article).subscribe(
      (res) => {
        this.loading = true;
        this.articles = res.rows;
        this.cantpages = res.pagination.pages;
        this.loading = false;
      },
      (error) => {
        console.error(<any>error);
      }
    );
  };

  onPrev = (): void => {
    this.loading = true;
    this.page--;
    const filter: FilterContainer = this.articleService.getStorage();
    this.getProducts(filter.article.name, filter.departmentId);
  };

  onNext(): void {
    this.loading = true;
    this.page++;
    const filter: FilterContainer = this.articleService.getStorage();
    this.getProducts(filter.article.name, filter.departmentId);
  }
}
